{% block ap_prices_check %}
    <sw-page class="ap-prices-check">
        <template #content>
            <sw-card-view>
                <div class="sw-card">
                    <div class="sw-card__title" style="padding: 10px;">{{ $t('ap-prices.content.configInformationText') }}</div>
                    <div class="sw-card__content">
                        <div class="product-basic-form">
                            <div class="sw-container"
                                 style="grid-template-columns: 1fr 1fr 1fr; gap: 0px 30px; place-items: stretch;">
                                <div class="sw-inherit-wrapper">
                                    <div
                                            class="sw-field sw-block-field sw-contextual-field sw-field--text sw-field--default">
                                        <div class="sw-field__label">
                                            &nbsp;
                                        </div>
                                        <sw-button-process variant="primary" :isLoading="isConfigLoading"
                                                           :processSuccess="processConfigSuccess"
                                                           @process-finish="apConfigFinish" @click="apOnClickConfigFetch">
                                            {{ $t('ap-prices.content.checkConfigText') }}
                                        </sw-button-process>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="sw-data-grid" v-if="showConfigResultsContainer" style="border: 1px solid #d1d9e0;">
                            <div class="sw-data-grid__wrapper">
                                <table class="sw-data-grid__table" v-if="isConfigError" ref="table">
                                    <tbody class="sw-data-grid__body">
                                    <template v-for="valueMsg in errorConfigMessage">
                                        <tr class="sw-data-grid__row">
                                            <td class="sw-data-grid__cell sw-data-grid__cell--header sw-data-grid__cell--align-left">
                                                <div class="sw-data-grid__cell-content">
                                                        <span class="sw-data-grid__cell-value">
                                                            <sw-icon name="regular-times-circle" color="#fc427b"></sw-icon>
                                                        </span>
                                                </div>
                                            </td>
                                            <td class="sw-data-grid__cell sw-data-grid__cell--header sw-data-grid__cell--align-left">
                                                <div class="sw-data-grid__cell-content">
                                                        <span class="sw-data-grid__cell-value">
                                                            {{ $t('ap-prices.content.error') }}
                                                        </span>
                                                </div>
                                            </td>
                                            <td class="sw-data-grid__cell sw-data-grid__cell--header sw-data-grid__cell--align-left">
                                                <div class="sw-data-grid__cell-content">
                                                        <span class="sw-data-grid__cell-value">
                                                            {{ $t(valueMsg) }}
                                                        </span>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-for="valueMsg in warningConfigMessage">
                                        <tr class="sw-data-grid__row">
                                            <td class="sw-data-grid__cell sw-data-grid__cell--header sw-data-grid__cell--align-left">
                                                <div class="sw-data-grid__cell-content">
                                                        <span class="sw-data-grid__cell-value">
                                                            <sw-icon name="regular-minus-circle" color="#f39c12"></sw-icon>
                                                        </span>
                                                </div>
                                            </td>
                                            <td class="sw-data-grid__cell sw-data-grid__cell--header sw-data-grid__cell--align-left">
                                                <div class="sw-data-grid__cell-content">
                                                        <span class="sw-data-grid__cell-value">
                                                            {{ $t('ap-prices.content.warning') }}
                                                        </span>
                                                </div>
                                            </td>
                                            <td class="sw-data-grid__cell sw-data-grid__cell--header sw-data-grid__cell--align-left">
                                                <div class="sw-data-grid__cell-content">
                                                        <span class="sw-data-grid__cell-value">
                                                            {{ $t(valueMsg) }}
                                                        </span>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-for="valueMsg in successConfigMessage">
                                        <tr class="sw-data-grid__row">
                                            <td class="sw-data-grid__cell sw-data-grid__cell--header sw-data-grid__cell--align-left">
                                                <div class="sw-data-grid__cell-content">
                                                        <span class="sw-data-grid__cell-value">
                                                             <sw-icon name="default-basic-checkmark-circle" color="#1abc9c"></sw-icon>
                                                        </span>
                                                </div>
                                            </td>
                                            <td class="sw-data-grid__cell sw-data-grid__cell--header sw-data-grid__cell--align-left" colspan="2">
                                                <div class="sw-data-grid__cell-content">
                                                        <span class="sw-data-grid__cell-value">
                                                            {{ $t(valueMsg) }}
                                                        </span>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sw-card">
                    <div class="sw-card__title" style="padding: 10px;">{{ $t('ap-prices.content.informationText') }}</div>
                    <div class="sw-card__content">
                        <div class="product-basic-form">
                            <div class="sw-container"
                                 style="grid-template-columns: 1fr 1fr 1fr; gap: 0px 30px; place-items: stretch;">
                                <div class="sw-inherit-wrapper">
                                    <div
                                            class="sw-field sw-block-field sw-contextual-field sw-field--text sw-field--default">
                                        <div class="sw-field__label">
                                            <label
                                                    class="is--required">{{ $t('ap-prices.content.customersNumberText') }}</label>
                                        </div>
                                        <div class="sw-block-field__block">
                                            <input type="text" v-model="addressNumber">
                                        </div>
                                    </div>
                                </div>
                                <div class="sw-inherit-wrapper">
                                    <div
                                            class="sw-field sw-block-field sw-contextual-field sw-field--text sw-field--default">
                                        <div class="sw-field__label">
                                            <label
                                                    class="is--required">{{ $t('ap-prices.content.productsNumberText') }}</label>
                                        </div>
                                        <div class="sw-block-field__block">
                                            <input type="text" v-model="productNumber">
                                        </div>
                                    </div>
                                </div>
                                <div class="sw-inherit-wrapper">
                                    <div
                                            class="sw-field sw-block-field sw-contextual-field sw-field--text sw-field--default">
                                        <div class="sw-field__label">
                                            <label>{{ $t('ap-prices.content.quantityText') }}</label>
                                        </div>
                                        <div class="sw-block-field__block">
                                            <input type="text" v-model="productQuantity" value="0">
                                        </div>
                                    </div>
                                </div>
                                <div class="sw-inherit-wrapper">
                                    <sw-entity-single-select
                                            class="sw-customer-address-form__country-select"
                                            entity="country"
                                            :criteria="apCountryCriteria"
                                            :label="$tc('ap-prices.content.landText')"
                                            :placeholder="$tc('sw-customer.addressForm.placeholderCountry')"
                                            v-model:value="countryId">
                                    </sw-entity-single-select>
                                </div>
                                <div class="sw-inherit-wrapper">
                                    <sw-entity-single-select
                                            class="sw-customer-address-form__country-select"
                                            entity="language"
                                            :criteria="apLanguageCriteria"
                                            :label="$tc('ap-prices.content.langText')"
                                            :placeholder="$tc('ap-prices.content.placeholderLang')"
                                            v-model:value="languageId">
                                    </sw-entity-single-select>
                                </div>
                                <div class="sw-inherit-wrapper">
                                    <div class="sw-field__label" style="height: 40px;">
                                        <label></label>
                                    </div>
                                    <div class="sw-block-field__block">
                                        <sw-checkbox-field
                                                v-model:value="debugFlag"
                                                class="sw-customer-base-info__checkbox-field"
                                                :label="$tc('ap-prices.content.placeholderDebug')"
                                                size="small"
                                        />
                                    </div>
                                </div>
                                <div class="sw-inherit-wrapper">
                                    <div
                                            class="sw-field sw-block-field sw-contextual-field sw-field--text sw-field--default">
                                        <div class="sw-field__label">
                                            &nbsp;
                                        </div>
                                        <sw-button-process variant="primary" :isLoading="isLoading"
                                                           :processSuccess="processSuccess"
                                                           @process-finish="apSaveFinish" @click="apOnClickFetch">
                                            {{ $t('ap-prices.content.getPricesText') }}
                                        </sw-button-process>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="sw-data-grid" v-if="showResultsContainer" style="border: 1px solid #d1d9e0;">
                            <div class="sw-data-grid__wrapper">
                                <table class="sw-data-grid__table" v-if="isError" ref="table">
                                    <thead class="sw-data-grid__header">
                                    <tr class="sw-data-grid__row">
                                        <th class="sw-data-grid__cell sw-data-grid__cell--header sw-data-grid__cell--selection">
                                            <div class="sw-data-grid__cell-content sw-field__error">
                                                {{ $t(errorMessage) }}
                                            </div>
                                        </th>
                                    </tr>
                                    </thead>
                                </table>
                                <table class="sw-data-grid__table" v-if="!isError" ref="table">
                                    <thead class="sw-data-grid__header">
                                    <tr class="sw-data-grid__row">
                                        <th class="sw-data-grid__cell sw-data-grid__cell--header sw-data-grid__cell--selection">
                                            <div class="sw-data-grid__cell-content">
                                                {{ $t(('ap-prices.content.addressInfo')) }}
                                            </div>
                                        </th>
                                        <th class="sw-data-grid__cell sw-data-grid__cell--header sw-data-grid__cell--selection">
                                            <div class="sw-data-grid__cell-content">
                                                {{ $t(('ap-prices.content.productInfo')) }}
                                            </div>
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody class="sw-data-grid__body">
                                    <tr class="sw-data-grid__row">
                                        <td class="sw-data-grid__cell sw-data-grid__cell--header sw-data-grid__cell--selection">
                                            <div class="sw-data-grid__cell-content" style="height: auto;">
                                                {{ dataAddressInfoResult.firstName }}
                                                &nbsp; {{ dataAddressInfoResult.lastName }}<br/>
                                                {{ dataAddressInfoResult.street }}<br/>
                                                {{ dataAddressInfoResult.zip }}&nbsp; {{ dataAddressInfoResult.city }}
                                                <br/>
                                                {{ dataAddressInfoResult.land }}
                                            </div>
                                        </td>
                                        <td class="sw-data-grid__cell sw-data-grid__cell--header sw-data-grid__cell--selection">
                                            <div class="sw-data-grid__cell-content" style="height: auto;white-space: unset;justify-content: left;padding-bottom: 5px;">
                                                {{ dataProductInfoResult.name }}
                                            </div>
                                            <div class="sw-data-grid__cell-content" v-if="dataProductInfoResult.warning" style="height: auto;white-space: unset;justify-content: left;padding-top: 5px;">
                                                <sw-icon name="regular-minus-circle" color="#f39c12"></sw-icon>
                                                <span style="margin-left: 10px;">{{ $t('ap-prices.warning.apLanguageInfoNotFound') }}</span>
                                            </div>
                                            <div class="sw-data-grid__cell-content" v-if="!dataProductInfoResult.warning" style="height: auto;white-space: unset;justify-content: left;padding-top: 5px;">
                                                {{ dataProductInfoResult.description }}
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                                <table class="sw-data-grid__table" v-if="!isError" ref="table">
                                    <thead class="sw-data-grid__header">
                                    <tr class="sw-data-grid__row">
                                        <template v-for="valueHead in dataHeadResult">
                                            <th class="sw-data-grid__cell sw-data-grid__cell--header sw-data-grid__cell--selection" style="min-width: fit-content;">
                                                <div class="sw-data-grid__cell-content">
                                                    {{ $t(valueHead) }}
                                                </div>
                                            </th>
                                        </template>
                                    </tr>
                                    </thead>
                                    <tbody class="sw-data-grid__body">
                                    <template v-for="valueBody,keyBody in dataBodyResult">
                                        <tr class="sw-data-grid__row">
                                            <template v-for="valueSubBody,keySubBody in dataBodyResult[keyBody]">
                                                <td class="sw-data-grid__cell sw-data-grid__cell--selection">
                                                    <div class="sw-data-grid__cell-content">
                                                        {{ valueSubBody }}
                                                    </div>
                                                </td>
                                            </template>
                                        </tr>
                                    </template>
                                    </tbody>
                                </table>
                                <table class="sw-data-grid__table" v-if="!isError" ref="table">
                                    <thead class="sw-data-grid__header">
                                    <tr class="sw-data-grid__row" style="border-top: 1px solid #d1d9e0;">
                                        <template v-for="valueHead in dataDiscountHeadResult">
                                            <th class="sw-data-grid__cell sw-data-grid__cell--header sw-data-grid__cell--selection">
                                                <div class="sw-data-grid__cell-content">
                                                    {{ $t(valueHead) }}
                                                </div>
                                            </th>
                                        </template>
                                    </tr>
                                    </thead>
                                    <tbody class="sw-data-grid__body">
                                    <template v-for="valueBody,keyBody in dataDiscountBodyResult">
                                        <tr class="sw-data-grid__row">
                                            <template v-for="valueSubBody,keySubBody in dataDiscountBodyResult[keyBody]">
                                                <td class="sw-data-grid__cell sw-data-grid__cell--selection">
                                                    <div class="sw-data-grid__cell-content">
                                                        {{ valueSubBody }}
                                                    </div>
                                                </td>
                                            </template>
                                        </tr>
                                    </template>
                                    </tbody>
                                </table>
                                <table class="sw-data-grid__table" v-if="!isError" ref="table">
                                    <tbody class="sw-data-grid__body" style="border-top: 1px solid #d1d9e0;">
                                    <tr class="sw-data-grid__row">
                                        <td class="sw-data-grid__cell sw-data-grid__cell--selection">
                                            <div class="sw-data-grid__cell-content">
                                                <b>{{ $t('ap-prices.content.usedTax') }}</b>
                                            </div>
                                        </td>
                                        <td class="sw-data-grid__cell sw-data-grid__cell--selection">
                                            <div class="sw-data-grid__cell-content">
                                                {{ dataTaxResult.usedTax }} %
                                            </div>
                                        </td>
                                    </tr>
                                    <tr class="sw-data-grid__row">
                                        <td class="sw-data-grid__cell sw-data-grid__cell--selection">
                                            <div class="sw-data-grid__cell-content">
                                                <b>{{ $t('ap-prices.content.deliveryThresholdReached') }}</b>
                                            </div>
                                        </td>
                                        <td class="sw-data-grid__cell sw-data-grid__cell--selection">
                                            <div class="sw-data-grid__cell-content">
                                                {{ $t(dataTaxResult.deliveryThresholdReached) }}
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </sw-card-view>
        </template>
    </sw-page>
{% endblock %}
